module.exports = __webpack_public_path__ + "static/media/icon-schnelle-termine.55138efd.svg";